import { Sparkles,useTexture } from '@react-three/drei'

export default function Village()
{

    const relief  = useTexture('./displacementMap7.jpg')



    return <>

        
        {/* SOL VERT */ }
        <mesh receiveShadow  rotation-x={-Math.PI / 2}>
            <planeGeometry args={[1000,1000,2,2]}  />
            {/* <planeGeometry args={[1000,1000,2,2]}  /> */}
            <meshStandardMaterial  
                color="green" 
            />
        </mesh>

        {/* RELIEF  */ }
        <mesh receiveShadow castShadow rotation-x={-Math.PI / 2} position-y={-0.01}>
            <planeGeometry args={[25,25,100,100]}  />
            <meshStandardMaterial  
                color= {'#787046'} 
                displacementMap={relief} 
                displacementScale = {4}
            />
        </mesh>

        {/* LAC */ }
        <mesh receiveShadow rotation-x = {- Math.PI * 0.5} position={[0,0.01,0]}>
            <circleGeometry args={[1.8,  50]} />
            <meshStandardMaterial  color= {'#3b90c6'} />
        </mesh>

        <mesh receiveShadow rotation-x = {- Math.PI * 0.5} position={[0,0.009,0]}>
            <circleGeometry args={[2.2,  50]} />
            <meshStandardMaterial  color= {'#787046'} />
        </mesh>

        <mesh receiveShadow rotation-x = { Math.PI * 0} position={[0,0,0]}>
            <boxGeometry args={[500, 0.001, 0.5]} />
            <meshStandardMaterial  color= {'#787046'} />
        </mesh>

        {/* SPARKLES */ }
        <Sparkles
            scale={[2,1,2]}
        />



    </>

}
